
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industrial-design-registration",
      function () {
        return require("private-next-pages/industrial-design-registration/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industrial-design-registration"])
      });
    }
  